import { apiClient } from '@isocel/front-common';

import { Store } from './types';

export const fetchStores = async (): Promise<Store[]> => {
    const { data } = await apiClient().get(`/stores`);
    return (data as any[])
        .map((s) => ({ ...s, id: s.id || s._id } as Store))
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
};

export const updateStore = async (
    id: string,
    payload: {
        receptionAutoActiver?: boolean;
        receptionAutoDelai?: number | null;
        aliceCode?: string;
    }
): Promise<Store> => {
    const { data } = await apiClient().put(`/stores/${id}`, payload);
    return data;
};
